// src/components/Navbar/MainMenu/index.js
import React from 'react';
import MenuLink from './MenuLink';
import ProductsMenu from './ProductsMenu';
import { useSelector } from 'react-redux';

const MainMenu = ({ isMobile, onClose }) => {
  const user = useSelector(state => state.auth.currentUser);
  
  return (
    <div className={`flex ${isMobile ? 'flex-col space-y-6' : 'items-center space-x-8'}`}>
      <MenuLink to="/" label="Inicio" onClick={onClose} />
      <ProductsMenu onClose={onClose} />
      <MenuLink to="/about" label="Nosotros" onClick={onClose} />
      <MenuLink to="/contact" label="Contacto" onClick={onClose} />

      {/* Solo mostrar si es admin */}
      {user?.role === 'admin' && (
        <MenuLink to="/admin/41656338" label="Admin" onClick={onClose} />
      )}
    </div>
  );
};

export default MainMenu;